import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BHMarketItems extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BHMarketItems'
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
const servicePath = 'bh-market-items';
const servicePlugin = makeServicePlugin({
  Model: BHMarketItems,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin